import { Button, Icon } from '@monash/portal-react';
import c from './filters-button.module.scss';

const FiltersButton = ({ ...buttonProps }) => {
  return (
    <Button
      icon={<Icon.Filter />}
      variant="text"
      className={c.filtersButton}
      size="large"
      {...buttonProps}
    >
      Filters
    </Button>
  );
};

export default FiltersButton;
